import { BLOCK_TYPES } from './blockTypes'
// Helper function to convert padding object to CSS string
const paddingToCSS = (padding) => {
  if (!padding) return '0';
  const { top = 0, right = 0, bottom = 0, left = 0 } = padding;
  const format = (val) => (typeof val === 'number' ? `${val}px` : val);
  return `${format(top)} ${format(right)} ${format(bottom)} ${format(left)}`;
};
// Helper function to convert spacing object to CSS properties array
const getSpacingObject = (spacing, type) => {
  if (!spacing) return [];
  const { top = 0, right = 0, bottom = 0, left = 0 } = spacing;
  const format = (val) => (typeof val === 'number' ? `${val}px` : val);
  return [`${type}: ${format(top)} ${format(right)} ${format(bottom)} ${format(left)}`];
};

// Helper function to generate email-safe CSS
const generateBlockCSS = (block) => {
  console.log('Generating a block')
  console.log(block)
  const { properties } = block;
  let styles = [];

  // Common styles
  if (properties.backgroundColor && properties.backgroundColor !== 'transparent') {
    styles.push(`background-color: ${properties.backgroundColor}`);
  }
  if (properties.color) {
    styles.push(`color: ${properties.color}`);
  }
  if (properties.fontSize) {
    styles.push(`font-size: ${properties.fontSize}px`);
  }
  if (properties.fontFamily) {
    styles.push(`font-family: ${properties.fontFamily}`);
  }
  if (properties.textAlign) {
    styles.push(`text-align: ${properties.textAlign}`);
  }
  if (properties.padding) {
    styles.push(`padding: ${paddingToCSS(properties.padding)}`);
  }
  if (properties.margin) {
    styles.push(`margin: ${paddingToCSS(properties.margin)}`);
  }
  if (properties.borderRadius) {
    styles.push(`border-radius: ${properties.borderRadius}px`);
  }

  return styles.join('; ');
};

// Generate HTML for different block types
const generateBlockHTML = (block) => {
  //console.log('Generating a block html')
  //console.log(block)
  const { type, properties } = block;
  const styles = generateBlockCSS(block);

  switch (type) {
    case BLOCK_TYPES.HEADER:
      return `
        <tr>
          <td style="${styles}">
            <${properties.level || 'h1'} style="margin: ${paddingToCSS(properties.margin)};font-family:${properties.fontFamily}; font-size: ${properties.fontSize || 28}px; color: ${properties.color || '#333333'}; text-align: ${properties.textAlign || 'center'}; font-weight: ${properties.fontWeight}">
              ${properties.title || ''}
            </${properties.level || 'h1'}>
          </td>
        </tr>`;

    case BLOCK_TYPES.TEXT:
      const htmlTag = properties.htmlTag || 'p';
      const useStrong = properties.useStrong || false;
      const textContent = properties.content || '';
      const wrappedContent = useStrong ? `<strong>${textContent}</strong>` : textContent;
      
      return `
        <tr>
          <td style="${styles}">
            <${htmlTag} style="margin: 0; line-height: ${properties.lineHeight || 1.5}; font-family:${properties.fontFamily}; font-size: ${properties.fontSize || 28}px; color: ${properties.color || '#333333'}; text-align: ${properties.textAlign || 'center'}; font-weight: ${properties.fontWeight}">
              ${wrappedContent}
            </${htmlTag}>
          </td>
        </tr>`;

    case BLOCK_TYPES.LISTITEMS:
      const listType = properties.listType || 'ul';
      const items = properties.items || [];
      const listStyleType = properties.listStyleType || (listType === 'ul' ? 'disc' : 'decimal');
      const itemSpacing = properties.itemSpacing || 8;
      
      const listItemsHTML = items.map(item => `
        <li style="margin-bottom: ${itemSpacing}px; color: ${properties.color || '#000000'};">
          ${item}
        </li>
      `).join('');
      
      return `
        <tr>
          <td style="${styles}">
            <${listType} style="list-style-type: ${listStyleType}; padding-left: 20px; margin: 0; font-size: ${properties.fontSize || 16}px; font-family: ${properties.fontFamily || 'Arial, sans-serif'}; font-weight: ${properties.fontWeight || 'normal'}; color: ${properties.color || '#000000'}; text-align: ${properties.textAlign || 'left'}; line-height: ${properties.lineHeight || 1.5};">
              ${listItemsHTML}
            </${listType}>
          </td>
        </tr>`;

    case BLOCK_TYPES.BUTTON:
      const buttonStyles = [
        `background-color: ${properties.buttonbackgroundColor || '#007bff'}`,
        `color: ${properties.color || '#ffffff'}`,
        `font-size: ${properties.fontSize || 16}px`,
        `font-family: ${properties.fontFamily || 'Arial, sans-serif'}`,
        `text-decoration: none`,
        `padding: ${paddingToCSS(properties.buttonpadding)}`,
        `margin: ${paddingToCSS(properties.buttonmargin)}`,
        `border-radius: ${properties.buttonborderRadius || 4}px`,
        `display: inline-block`,
        `font-weight: bold`
      ].join('; ');

      return `
        <tr>
          <td style="${styles}">
            <table width="100%" cellpadding="0" cellspacing="0" border="0px" style="text-align: ${properties.textAlign};">
              <tr>
                <td>
                  <a href="${properties.link || '#'}" style="${buttonStyles}">
                    ${properties.text || 'Button'}
                  </a>
                </td>
              </tr>
            </table>
          </td>
        </tr>`;

    case BLOCK_TYPES.IMAGE:
      return `
        <tr>
          <td style="${styles}">
          <table width="100%" cellpadding="0" cellspacing="0" border="0px" style="text-align: ${properties.textAlign};">
              <tr>
                <td style="overflow: hidden;">
                   <img src="${properties.src || ''}" alt="${properties.alt || ''}" style="width: ${properties.width}; height: ${properties.height}; display: inline-block; border-radius:${properties.imgborderRadius || 0}px;">
          </td>
              </tr>
            </table>
            </td>
        </tr>`;

    case BLOCK_TYPES.DIVIDER:
      return `
        <tr>
          <td style="${styles}">
            <hr style="border: none; border-top: ${properties.height}px solid ${properties.dividerbackgroundColor || '#cccccc'}; margin: 0;">
          </td>
        </tr>`;

    case BLOCK_TYPES.SPACER:
      return `
        <tr>
          <td style="height: ${properties.height || 20}px; line-height: ${properties.height || 20}px;">&nbsp;</td>
        </tr>`;
   case BLOCK_TYPES.HTMLCONTENT:
      return `
        <tr>
          <td style="${styles}">
            ${properties.htmlContent || ''}
          </td>
        </tr>`;
   // Email-compliant HTML generation for COLUMN and CONTAINER blocks
case BLOCK_TYPES.COLUMN:
  const columnStyles = [
    `width: ${properties.width || '100%'}`,
    `min-height: ${properties.minHeight || 50}px`,
    `background-color: ${properties.backgroundColor || 'transparent'}`,
    `vertical-align: top`,
    `border-collapse: collapse`,
    `mso-table-lspace: 0pt`,
    `mso-table-rspace: 0pt`,
    ...getSpacingObject(properties.padding, 'padding'),
    ...getSpacingObject(properties.margin, 'margin')
  ].filter(Boolean).join('; ');
  
  const columnChildren = block.children ? 
    block.children.map(child => generateBlockHTML(child)).join('') : '';
  
  return `
    <td style="${columnStyles}">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        ${columnChildren}
      </table>
    </td>`;

case BLOCK_TYPES.COLUMNCONTAINER:
  const columnContainerStyles = [
    `width: ${properties.width || '100%'}`,
    `min-height: ${properties.minHeight || 100}px`,
    `background-color: ${properties.backgroundColor || 'transparent'}`,
    `border-collapse: collapse`,
    `mso-table-lspace: 0pt`,
    `mso-table-rspace: 0pt`,
    ...getSpacingObject(properties.padding, 'padding'),
    ...getSpacingObject(properties.margin, 'margin')
  ].filter(Boolean).join('; ');
  
  const columnNumbers = parseInt(properties.columnnumbers || 3);
  const columnGap = properties.columngap || '5px';
  const alignItems = properties.alignItems || 'center';
  
  // Calculate column widths based on specified widths or auto-distribute
  const getColumnWidth = (index) => {
    const widthProperty = `column${index + 1}width`;
    const specifiedWidth = properties[widthProperty];
    
    if (specifiedWidth && specifiedWidth !== 'auto') {
      return specifiedWidth;
    }
    
    // Auto-distribute remaining width
    return `${100 / columnNumbers}%`;
  };
  
  // Generate columns HTML
  let columnsHTML = '';
  for (let i = 0; i < columnNumbers; i++) {
    const columnWidth = getColumnWidth(i);
    const isLastColumn = i === columnNumbers - 1;
    
    // Find corresponding child column or create empty one
    const childColumn = block.children && block.children[i] ? block.children[i] : null;
    const columnContent = childColumn ? generateBlockHTML(childColumn) : '';
    
    const columnCellStyles = [
      `width: ${columnWidth}`,
      `vertical-align: ${alignItems}`,
      `border-collapse: collapse`,
      `mso-table-lspace: 0pt`,
      `mso-table-rspace: 0pt`,
      !isLastColumn ? `padding-right: ${columnGap}` : ''
    ].filter(Boolean).join('; ');
    
    columnsHTML += `
      <td style="${columnCellStyles}">
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
          ${columnContent}
        </table>
      </td>`;
  }
  
  return `
    <tr>
      <td style="${columnContainerStyles}">
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
          <tr>
            ${columnsHTML}
          </tr>
        </table>
      </td>
    </tr>`;

case BLOCK_TYPES.CONTAINER:
  const containerStyles = [
    `width: ${properties.width || '100%'}`,
    `min-height: ${properties.minHeight || 50}px`,
    `background-color: ${properties.backgroundColor || 'transparent'}`,
    `border-collapse: collapse`,
    `mso-table-lspace: 0pt`,
    `mso-table-rspace: 0pt`,
    ...getSpacingObject(properties.padding, 'padding'),
    ...getSpacingObject(properties.margin, 'margin')
  ].filter(Boolean).join('; ');
  
  const containerChildren = block.children ? 
    block.children.map(child => generateBlockHTML(child)).join('') : '';
  
  // Check if container has column children for proper layout
  const hasColumnChildren = block.children && 
    block.children.some(child => child.type === BLOCK_TYPES.COLUMN);
  
  if (hasColumnChildren) {
    // Multi-column layout using table structure
    return `
      <tr>
        <td style="${containerStyles}">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
            <tr>
              ${containerChildren}
            </tr>
          </table>
        </td>
      </tr>`;
  } else {
    // Single column layout
    return `
      <tr>
        <td style="${containerStyles}">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
            ${containerChildren}
          </table>
        </td>
      </tr>`;
  }
    default:
      return '';
  }
};

export function htmlExport(blocks = [], globalProperties = {}, emailSubject = 'Email Template') {
  const blocksHTML = blocks.map(block => generateBlockHTML(block)).join('');
  const globalPadding = paddingToCSS(globalProperties.padding);
  const globalMargin = paddingToCSS(globalProperties.margin);
  console.log('globalPadding')
  console.log(globalPadding)
  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>${emailSubject}</title>
    <!--[if mso]>
    <noscript>
        <xml>
            <o:OfficeDocumentSettings>
                <o:AllowPNG/>
                <o:PixelsPerInch>96</o:PixelsPerInch>
            </o:OfficeDocumentSettings>
        </xml>
    </noscript>
    <![endif]-->
    <style type="text/css">
        /* Reset styles */
        body, table, td, p, a, span, div { 
            -webkit-text-size-adjust: 100%; 
            -ms-text-size-adjust: 100%; 
        }
        table, td { 
            mso-table-lspace: 0pt; 
            mso-table-rspace: 0pt; 
        }
        img { 
            -ms-interpolation-mode: bicubic; 
            border: 0; 
            outline: none; 
            text-decoration: none; 
        }
        
        /* Client-specific styles */
        .ExternalClass { width: 100%; }
        .ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div { 
            line-height: 100%; 
        }
        
        /* Mobile styles */
        @media only screen and (max-width: 480px) {
            .email-container { 
                width: 100% !important; 
                max-width: 100% !important; 
            }
            .mobile-padding { 
                padding: 10px !important; 
            }
        }
    </style>
</head>
<body style="margin: 0; padding: 0; background-color: ${globalProperties.emailBackgroundColor || '#e0e0e0'}; font-family: ${globalProperties.fontFamily || 'Arial, sans-serif'};">
    <table cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: ${globalProperties.emailBackgroundColor || '#e0e0e0'};">
        <tr>
            <td align="center" ><p style="color:#78829d;">${globalProperties.preheaderText}</p> </td>
        </tr>
        <tr>
            <td align="center" style="">
                <table class="email-container" cellpadding="0" cellspacing="0" border="0" width="${globalProperties.emailWidth || 600}" style="margin:${globalMargin};padding: ${globalPadding};max-width: ${globalProperties.emailWidth || 600}px; background-color: ${globalProperties.backgroundColor || '#ffffff'}; border-radius: ${globalProperties.emailBorderRadius || 0}px;">
                    ${blocksHTML}
                </table>
            </td>
        </tr>
         <tr>
            <td align="center" ><p style="color:#78829d;">${globalProperties.footerText}</p> </td>
        </tr>
    </table>
</body>
</html>`;
}